import { default as store } from "../../../store";
import { Query as QueryBase } from "../../base/routing";

export class Query extends QueryBase {
  constructor(source: { [key: string]: string | string[] }) {
    super(source);
  }

  get patientNo(): string {
    // 患者番号は固定の設定値を使う
    return store.getters.configuration.formatEditor.behavior.patient.fixed.code;
  }

  get formatId(): number {
    return this.readFirstAsInteger("formatId");
  }

  get archiveId(): number {
    return this.readFirstAsInteger("archiveId");
  }

  get temporaryFormatId(): number {
    return this.readFirstAsInteger("temporaryFormatId");
  }

  get shouldNotifyRegistered(): boolean {
    return this.readFirstAsBoolean("shouldNotifyRegistered");
  }

  get isTemporary(): boolean {
    return this.readFirstAsBoolean("isTemporary");
  }
}
